import $ from 'jquery';
import 'bootstrap';
import './previous-sessions.js';
import './upcoming-sessions.js';
import './reset-password.js';
import './change-password.js';
import 'cropperjs';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';

// Install modules
import ResetPassword from './reset-password.js';
import TutorProfile from './tutorprofile.js';
 

const site = (() => {
	function getSwiper() {
		Swiper.use([Navigation]); 
		let swiper = new Swiper('.swiper', {
			// Swiper options
			loop: true,
			slidesPerView: 1,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			}
		});

		return swiper;
	}
	function getResetPassword() {
		return new ResetPassword();
	}

	function toggleStar(url) {

		let data = { Url: encodeURIComponent(url) };

		fetch('/App/ToggleBookmark', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			}
			, body: JSON.stringify(data)
		})
			.then(response => {
				if (response.ok) {
					updateTutorLocker();
				}
			});

	}

	function updateTutorLocker() {
		// get bookmarks
		fetch('/app/getBookmarks', {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json'
			}
		})
			.then(response => {
				if (response.ok) {
					return response.json();
				}
			}).then(data => {
				let bookMarks = data.bookMarks;
				let links = document.getElementsByClassName("tutor-locker");
				// iterate over links
				Array.from(links).forEach(link => {

					let star = link.parentElement.getElementsByClassName("fa-star")[0];
					star.textContent = "";
					let match = bookMarks.find(x => {
						let decoded = decodeURIComponent(x.url);
						return decoded.toLocaleLowerCase() == link.href.toLocaleLowerCase();
					});

					if (match) {
						star.classList.add("fa-solid");
						star.classList.remove("fa-regular");
					}
					else {
						star.classList.add("fa-regular");
						star.classList.remove("fa-solid");
					}

				});


			});

	}
	function addTutorLocker() {
		//return; // for indexing site
		// get bookmarks
		fetch('/app/getBookmarks', {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json'
			}
		})
			.then(response => {
				if (response.ok) {
					return response.json();
				}
			})
			.then(data => {
				let bookMarks = data.bookMarks;
				let links = document.getElementsByClassName("tutor-locker");
				// iterate over links
				Array.from(links).forEach(link => {

					let p = link.parentElement;
					let star = document.createElement("span");
					star.href = "#";
					star.classList.add("fa-star");
					//star.style.textShadow = "0 0 1px black, 0 0 1px black, 0 0 1px black, 0 0 1px black";
					star.style.textDecoration = "none";
					star.onclick = () => {
						toggleStar(link.href);
					};
					let match = bookMarks.find(x => {
						let decoded = decodeURIComponent(x.url);
						return decoded.toLocaleLowerCase() == link.href.toLocaleLowerCase();
					});

					if (match) {
						star.classList.add("fa-solid");
						star.classList.remove("fa-regular");
					}
					else {
						star.classList.add("fa-regular");
						star.classList.remove("fa-solid");
					}

					p.prepend(star);

				});


			});

	}

	function toggleSetting(settingName, value) {
		fetch('/App/ToggleSetting', {
			body: JSON.stringify({ settingName: settingName, settingValue: value }),
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			}
		});
		
	}

	function decimalToStars(decimal) {
		decimal = document.getElementById(decimal).innerHTML;
		const fullStars = Math.floor(decimal);
		const hasHalfStar = decimal - fullStars >= 0.5;
		const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

		let stars = '';

		for (let i = 0; i < fullStars; i++) {
			stars += '<i class="fa fa-star"></i>';
		}

		if (hasHalfStar) {
			stars += '<i class="fa fa-star-half"></i>';
		}


		stars += '<span class="fw-bold fs-2 text-decoration-underline">' + decimal + '</span>';
		document.getElementById('tutor-star-rating').innerHTML = stars;
		return stars;
	}

	function enableToolTip() {
		var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
		var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
			return new bootstrap.Tooltip(tooltipTriggerEl)
		})
	}

	let currentStep = 1;
	const totalSteps = 8;

	function updateStepBar() {
		const steps = document.querySelectorAll('.step-wrapper');
		const contents = document.querySelectorAll('.step-content');

		steps.forEach((step, index) => {
			const stepNum = index + 1;
			step.classList.remove('active', 'completed');

			if (stepNum < currentStep) {
				step.classList.add('completed');
			} else if (stepNum === currentStep) {
				step.classList.add('active');
			}
		});

		contents.forEach((content, index) => {
			content.classList.toggle('active', index + 1 === currentStep);
		});
	}

	function nextStep() {
		if (currentStep < totalSteps) {
			currentStep++;
			updateStepBar();
		}
	}

	function prevStep() {
		if (currentStep > 1) {
			currentStep--;
			updateStepBar();
		}
	}

	
	function formatDate(date, format, utc) {
		var MMMM = [
			'\x00',
			'January',
			'February',
			'March',
			'April',
			'May',
			'June',
			'July',
			'August',
			'September',
			'October',
			'November',
			'December'
		];
		var MMM = [
			'\x01',
			'Jan',
			'Feb',
			'Mar',
			'Apr',
			'May',
			'Jun',
			'Jul',
			'Aug',
			'Sep',
			'Oct',
			'Nov',
			'Dec'
		];
		var dddd = [
			'\x02',
			'Sunday',
			'Monday',
			'Tuesday',
			'Wednesday',
			'Thursday',
			'Friday',
			'Saturday'
		];
		var ddd = ['\x03', 'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

		function ii(i, len) {
			var s = i + '';
			len = len || 2;
			while (s.length < len) s = '0' + s;
			return s;
		}

		var y = utc ? date.getUTCFullYear() : date.getFullYear();
		format = format.replace(/(^|[^\\])yyyy+/g, '$1' + y);
		format = format.replace(
			/(^|[^\\])yy/g,
			'$1' + y.toString().substr(2, 2)
		);
		format = format.replace(/(^|[^\\])y/g, '$1' + y);

		var M = (utc ? date.getUTCMonth() : date.getMonth()) + 1;
		format = format.replace(/(^|[^\\])MMMM+/g, '$1' + MMMM[0]);
		format = format.replace(/(^|[^\\])MMM/g, '$1' + MMM[0]);
		format = format.replace(/(^|[^\\])MM/g, '$1' + ii(M));
		format = format.replace(/(^|[^\\])M/g, '$1' + M);

		var d = utc ? date.getUTCDate() : date.getDate();
		format = format.replace(/(^|[^\\])dddd+/g, '$1' + dddd[0]);
		format = format.replace(/(^|[^\\])ddd/g, '$1' + ddd[0]);
		format = format.replace(/(^|[^\\])dd/g, '$1' + ii(d));
		format = format.replace(/(^|[^\\])d/g, '$1' + d);

		var H = utc ? date.getUTCHours() : date.getHours();
		format = format.replace(/(^|[^\\])HH+/g, '$1' + ii(H));
		format = format.replace(/(^|[^\\])H/g, '$1' + H);

		var h = H > 12 ? H - 12 : H == 0 ? 12 : H;
		format = format.replace(/(^|[^\\])hh+/g, '$1' + ii(h));
		format = format.replace(/(^|[^\\])h/g, '$1' + h);

		var m = utc ? date.getUTCMinutes() : date.getMinutes();
		format = format.replace(/(^|[^\\])mm+/g, '$1' + ii(m));
		format = format.replace(/(^|[^\\])m/g, '$1' + m);

		var s = utc ? date.getUTCSeconds() : date.getSeconds();
		format = format.replace(/(^|[^\\])ss+/g, '$1' + ii(s));
		format = format.replace(/(^|[^\\])s/g, '$1' + s);

		var f = utc ? date.getUTCMilliseconds() : date.getMilliseconds();
		format = format.replace(/(^|[^\\])fff+/g, '$1' + ii(f, 3));
		f = Math.round(f / 10);
		format = format.replace(/(^|[^\\])ff/g, '$1' + ii(f));
		f = Math.round(f / 10);
		format = format.replace(/(^|[^\\])f/g, '$1' + f);

		var T = H < 12 ? 'AM' : 'PM';
		format = format.replace(/(^|[^\\])TT+/g, '$1' + T);
		format = format.replace(/(^|[^\\])T/g, '$1' + T.charAt(0));

		var t = T.toLowerCase();
		format = format.replace(/(^|[^\\])tt+/g, '$1' + t);
		format = format.replace(/(^|[^\\])t/g, '$1' + t.charAt(0));

		var tz = -date.getTimezoneOffset();
		var K = utc || !tz ? 'Z' : tz > 0 ? '+' : '-';
		if (!utc) {
			tz = Math.abs(tz);
			var tzHrs = Math.floor(tz / 60);
			var tzMin = tz % 60;
			K += ii(tzHrs) + ':' + ii(tzMin);
		}
		format = format.replace(/(^|[^\\])K/g, '$1' + K);

		var day = (utc ? date.getUTCDay() : date.getDay()) + 1;
		format = format.replace(new RegExp(dddd[0], 'g'), dddd[day]);
		format = format.replace(new RegExp(ddd[0], 'g'), ddd[day]);

		format = format.replace(new RegExp(MMMM[0], 'g'), MMMM[M]);
		format = format.replace(new RegExp(MMM[0], 'g'), MMM[M]);

		format = format.replace(/\\(.)/g, '$1');

		return format;
	}

	function processSpanUTCTimes(v) {
		if (v) {
			var $v = $(v),
				utcTime = $v.attr('data-utcTime'),
				utcFormat = $v.attr('data-utcFormat');

			if (
				utcTime === undefined ||
				utcTime == null ||
				utcTime == '' ||
				!$v ||
				$v == null
			)
				return;

			var d = new Date(Date.UTC.apply(null, utcTime.split(',')));

			if ($v.is('input')) {
				$v.val(_wireup.formatDate(d, utcFormat));
			} else if ($v.is('select')) {
				var selOpt = _wireup.formatDate(d, utcFormat);
				$v.find('option[value="' + selOpt + '"]').attr(
					'selected',
					'selected'
				);
			} else {
				$v.html(this.formatDate(d, utcFormat));
			}
			return v;
		} else {
			$(
				'span[data-utcTime], input[data-utcTime], select[data-utcTime]'
			).each(function (i, v) {
				var $v = $(v),
					utcTime = $v.attr('data-utcTime'),
					utcFormat = $v.attr('data-utcFormat');

				if (
					utcTime === undefined ||
					utcTime == null ||
					utcTime == '' ||
					!$v ||
					$v == null
				)
					return;

				var d = new Date(Date.UTC.apply(null, utcTime.split(',')));

				if ($v.is('input')) {
					$v.val(formatDate(d, utcFormat));
				} else if ($v.is('select')) {
					var selOpt = formatDate(d, utcFormat);
					$v.find('option[value="' + selOpt + '"]').attr(
						'selected',
						'selected'
					);
				} else {
					$v.html(formatDate(d, utcFormat));
				}
			});
		}
	}

	function removeContent(userType) // pte or ic
	{
		$(`.${userType}`).each(function (i, v) {
			$(v).remove();
		});
	}

	function createAlert(alertType, message) {

		let alert = document.createElement('div');
		alert.classList.add("alert","alert-dismissable","fade","show","rounded-3")
		alert.role = 'alert';
		if (alertType == 'success')
			alert.classList.add("alert-success");
		else
			alert.classList.add("alert-failure");
		let d = document.createElement('div');
		d.classList.add("container-fluid","mt-0","pe-0","text-center")
		let s = document.createElement('strong');
		s.innerHTML = message;
		d.appendChild(s);
		let b = document.createElement('button');
		b.classList.add("btn", "btn-close", "align-self-start", "ms-auto");
		b.type = 'button';
		b.setAttribute('data-bs-dismiss', 'alert');
		b.ariaLabel = "Close";
		d.appendChild(b);

		alert.appendChild(d);
		return alert;


	}

	function getTutorProfile() {
		return new TutorProfile();
	}
	


	async function refreshCounterAsync() {	

		// Only run with https.
		if (window.location.protocol !== "https:") {
			return;
		}

		const domSelector = document.querySelector("#session-count");
		if (!domSelector) {
				return;
		}

		try {
			const result = await fetch("/Auth/GetTotalSessionsCount", {
				method: "POST",
				headers: {
						"Content-Type": "application/json"
				}
			});

			// if null, exit
			if (!result) {
					return;
			}

			const data = await result.json();		

			// if null, exit
			if (!data) {
					return;
			}			

			domSelector.innerHTML = ((data.totalCount) || 0).toLocaleString();		
			setTimeout(refreshCounterAsync, 30000);
		} catch {
			// Intentionally stop refreshing on error
		}
	}


	processSpanUTCTimes();

	window.enableToolTip = enableToolTip;
	window.updateStepBar = updateStepBar;
	window.updateTutorLocker = updateTutorLocker;
	window.addTutorLocker = addTutorLocker;
	window.removeContent = removeContent;
	window.toggleStar = toggleStar;
	window.createAlert = createAlert;
	window.toggleSetting = toggleSetting;
	window.getResetPassword = getResetPassword;
	window.getSwiper = getSwiper;
	window.getTutorProfile = getTutorProfile;	
	window.refreshCounterAsync = refreshCounterAsync;

})();
